import React, { Component } from 'react'
import Graphics from './Graphics';

import './Tubes.scss'

class EmptyTubeStand extends Component {
    render() {
        return (
            <ul style={{pointerEvents: 'none', zIndex: 2}}>
                <li
                  id="TubeStand" tabIndex={0}
                  aria-label={"Rack containing 6 tubes labeled S for sample, C1 for control 1, C2 for control 2, C3 for control 3, H2O for DNase-free water, and MM for master mix."}
                >
                    <Graphics id={this.props.id} />
                    <p aria-hidden="true" className="label" style={{display:"none"}}>Tube Stand</p>
                </li>
            </ul>
        );
    }
}

export default EmptyTubeStand;
